import { Requirement } from './requirement.model';
import { ShippingPriceDTO } from './shippingPriceDTO.model';

export class CampaignDTO {
    id: number;
    number: string;
    startDate: Date;
    endDate: Date;
    sequence: Number;
    startDateCC: Date;
    endDateCC: Date;
    startDatePick: Date;
    endDatePick: Date;
    minOrder: string;
    shippingAmount: string;
    minOrderShipping: string;
    firstOrderCredit: string;
    secondOrderCredit: string;
    thirdOrderCredit: string;
    fourthOrderCredit: string;
    fifthOrderCredit: string;
    status: string;
    requirements: Requirement[];
    shippingPriceList: Array<ShippingPriceDTO>;
    noticeOrderValue : number
}
